export enum PlacementContentKind {
    Documents = 'Documents',
    Images = 'Images',
    Videos = 'Videos'
}